import Alert, { AlertColor, AlertProps } from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Box from '@mui/material/Box';
import Typography from 'component/MarketPlace/Typography/Typography';
import { TruncatedText } from 'component/MarketPlace/Typography/Typography.style';
import React from 'react';
import { Outage } from './types';
import { useTheme } from "styled-components";
import { useMediaQuery, Theme } from '@mui/material';
import HlxButton from 'component/commonComponents/button/button';

export interface OutageNotificationProps {
  outage?: Outage;
  title?: string;
  onViewDetailsClick?: (outage: Outage) => void;
  alertProps?: AlertProps;
  locale?: any;
}

const mapSeverity = (severity = "") => {
  if (!severity) return "error";
  const mappedObject: Record<string, AlertColor> = {
    critical: "error",
  };
  return mappedObject[severity.toLowerCase()] || "error";
};

const OutageNotification = (props: OutageNotificationProps) => {
  const { outage = {}, title, onViewDetailsClick, alertProps, locale } = props;
  const theme = useTheme();

  const mdDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

  const severity = mapSeverity(outage.severity);
  const outageTitle =
    severity === "error" ? locale?.activeOutages : locale?.scheduledOutages;

  return (
    <Alert
      severity={severity}
      onClick={() => mdDown && onViewDetailsClick?.(outage)}
      {...alertProps}
      sx={{
        cursor: { xs: "pointer", md: "default" },
        ".MuiAlert-message": {
          width: "100%",
          display: "flex",
          gap: 2,
        },
        ...alertProps?.sx,
      }}
    >
      <Box flex="1" overflow="hidden">
        <AlertTitle>
          <TruncatedText maxlines={1} variant="inherit">
            <Typography
              variant="inherit"
              fontWeight={600}
              display="inline-block"
            >
              {title || outageTitle}
            </Typography>

            {outage.name && <>{` • ${outage.name}`}</>}
          </TruncatedText>
        </AlertTitle>

        {outage.content && (
          <TruncatedText maxlines={2} variant="body2">
            {outage.content.trim()}
          </TruncatedText>
        )}
      </Box>

      {onViewDetailsClick &&
        (
          <HlxButton
            variant="text"
            onClick={() => onViewDetailsClick(outage)}
            sx={{
              flexShrink: 0,
              alignSelf: 'center',
              display: 'block',
              fontFamily: theme?.uptimeFonts?.primary,
            }}
            label={locale?.viewDetails}
          />
        )}
    </Alert>
  );
};

export default OutageNotification;
